export default process.env.NODE_ENV === "development" ? `http://${window.location.hostname}:1338` : 'https://amp-api.embibe.com';
